<template>
  <div class="box">
    <div id="app-home">
      <div class="tree">
        <el-input
          class="input"
          placeholder="搜索关键字"
          v-model="filterText"
          prefix-icon="el-icon-search"
        >
        </el-input>
        <div class="treeList">
          <el-tree
            :data="treeList"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            :filter-node-method="filterNode"
            ref="tree"
            @check="checkTree"
            :default-expanded-keys="nodeList"
          >
            <div class="custom-tree-node" slot-scope="{ data }">
              <div>
                <img
                  v-if="data.children.length > 0"
                  src="@/assets/depament1.svg"
                  alt=""
                />
                <span>{{ data.label }}</span>
              </div>
              <span v-if="data.children.length > 0">
                <i class="el-icon-arrow-right"></i>
              </span>
            </div>
          </el-tree>
        </div>
      </div>
      <div class="submit">
        <el-button class="button" @click="query">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
import moment from "moment";
import { getToken } from "@/utils/cookie";
export default {
  name: "home",
  data() {
    return {
      treeList: [],
      filterText: "",
      infoList: {
        id: "",
        deptName: "",
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
      list: [],
      nodeList: [],
      type: "",
    };
  },
  created() {},
  mounted() {
    this.type = this.$route.query.type;
    this.getList();
    const str = JSON.parse(localStorage.getItem("node"));
    str && str.forEach((item) => {
      this.nodeList.push(item.id);
      this.list.push(item);
    });
    this.$refs.tree.setCheckedKeys(this.nodeList, true);
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    // 获取部门树
    getList() {
      api.getDeptTree({ ...this.infoList }).then((data) => {
        this.treeList = data.data;
      });
    },
    // 处理树节点选中事件
    checkTree() {
      let str = [];
      let nodes;
      if (this.type == "7") {
        // 异常推送的情况下需要传大部门id
        nodes = this.$refs.tree.getCheckedNodes(false);
      } else {
        nodes = this.$refs.tree.getCheckedNodes(true);
      }
      this.list = nodes;
      nodes.forEach((item) => {
        str.push({ id: item.id });
      });
      console.log(nodes, "nodes");
      localStorage.setItem("node", JSON.stringify(str));
    },
    // 过滤树节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //消息提示
    success() {
      this.$message({
        type: "success",
        message: "推送成功",
        duration: 2000,
      });
    },
    //消息提示
    error(err) {
      this.$message({
        type: "error",
        message: err.msg,
        duration: 2000,
      });
    },
    // 确认选择部门
    query() {
      const type = this.$route.query.type;
      const time = moment(new Date()).format("YYYY-MM-DD");
      let token = getToken();
      let list = [];
      this.list.forEach((item) => {
        list.push(item.id);
      });
      let obj = {
        operateTime: time,
        searchDate: "",
        searchType: "",
        operateType: "",
        operateNo: token,
        orgIdList: list.join(","),
      };
      if (type === "5") {
        obj.operateType = "6";
        api
          .getSelectSalaryList({ ...obj })
          .then(() => {
            this.success()
          })
          .catch((err) => {
            this.error(err)
          });
      } else if (type === "6") {
        obj.operateType = "7";
        api
          .getSelectSalaryList({ ...obj })
          .then(() => {
            this.success()
          })
          .catch((err) => {
            this.error(err)
          });
      } else if (type === "4") {
        api
          .atSendReport({ orgIdList: list.join(","), operateNo: token })
          .then(() => {
            this.success()
          })
          .catch((err) => {
            this.error(err)
          });
      } else if (type === "1") {
        api
          .sendInfo({ orgIdList: list.join(","), operateNo: token })
          .then(() => {
            this.success()
          })
          .catch((err) => {
            this.error(err)
          });
      } else if (type === "7") {
        api
          .sendKqYc({ orgid: list.join(",") })
          .then(() => {
            this.success()
          })
          .catch((err) => {
            this.error(err)
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
  }
}
.box {
  display: flex;
  justify-content: center;
}
#app-home {
  font-size: 16px * $zoom;
  position: relative;
  background: rgba(247, 249, 250, 1);
  min-height: 100vh;
  //   padding: 20px;
}
.tree {
  background: #ffffff;
  height: 1100px;
  .input {
    margin: 20px 0;
    ::v-deep .el-input__inner {
      width: 90%;
      height: 70px;
      margin-left: 5%;
      padding-left: 70px;
      background: rgba(235, 237, 242, 1);
      border: none;
    }
    ::v-deep .el-input__icon {
      margin-left: 40px;
      font-size: 34px;
      margin-top: 3px;
    }
  }
  .treeList {
    height: 940px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0px;
      height: 1px;
      background-color: rgba(240, 240, 240, 1);
    }
  }
  ::v-deep .el-checkbox {
    padding-left: 20px;
  }
  ::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
    display: none;
  }
  ::v-deep .el-tree-node__content {
    display: flex;
    height: 100px !important;
    padding: 0 20px;
    border-bottom: 1px solid #f6f6f6;
  }
  .custom-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    div {
      margin-left: 15px;
      display: flex;
      align-items: center;
      span {
        font-size: 32px;
        margin-left: 20px;
      }
    }
  }
  .el-icon-arrow-right {
    font-size: 32px;
    color: #ccc;
  }
}
.submit {
  position: absolute;
  bottom: 100px;
  width: 80%;

  .button {
    width: 100%;
    background: rgba(78, 162, 124, 1);
    color: #fff;
    height: 80px;
    font-size: 30px;
    padding-top: 15px;
    border-radius: 20px;
    margin-left: 12.5%;
  }
}
</style>
